<template>
    <div v-if="user">
        <b-modal
            v-model="modalShow"
            size="lg"
            :title="`${$locale.patient}編集`"
            ok-title="保存"
            ok-variant="yokumiru-orange"
            cancel-title="キャンセル"
            cancel-variant="yokumiru-gray"
            :ok-disabled="inProgress || !telObj.valid"
            :cancel-disabled="inProgress"
            @ok="handleOk"
            @cancel="close"
            @hidden="close">
            <form @submit.stop.prevent="editUser">
                <div>
                    <h5>基本情報</h5>
                    <div
                        v-if="$store.state.configs.timezone == 1"
                        class="row">
                        <div class="col-12 col-sm-6">
                            <div class="mb-3">
                                <label for="timezone">タイムゾーン設定</label>
                                <select
                                    v-model="user.timezone"
                                    id="timezone"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.timezone }">
                                    <option value="">選択してください</option>
                                    <option v-for="timezone in timezones" :value="timezone.key">
                                        {{ timezone.value }}
                                    </option>
                                </select>
                                <div v-if="errors.timezone"
                                     class="invalid-feedback d-block">
                                    {{ errors.timezone[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <div class="form-group m-form__group">
                                <label
                                    for="user_category_id"
                                    class="is-required-ja">
                                    {{ $locale.patient }}区分
                                </label>
                                <select
                                    v-model="selectedUserCategory"
                                    id="user_category_id"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.user_category_id }">
                                    <option :value="null">選択してください</option>
                                    <option
                                        v-for="userCategory in userCategories"
                                        :value="userCategory">
                                        {{ userCategory.name }}
                                    </option>
                                </select>
                                <div
                                    v-if="errors.user_category_id"
                                    class="invalid-feedback d-block">
                                    {{ errors.user_category_id[0] }}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group m-form__group">
                                <label for="user_code">所属コード</label>
                                <input
                                    v-model="user.user_code"
                                    id="user_code"
                                    type="text"
                                    class="form-control m-input"
                                    :class="{ 'is-invalid' : errors.user_code }"
                                    @change="onChangeUserCode">
                                <div
                                    v-if="errors.user_code"
                                    class="invalid-feedback d-block mt-1">
                                    {{ errors.user_code[0]}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- // 法人・団体の詳細ページからのみ編集可能とする -->
<!--                    <div class="row">-->
<!--                        <div class="col-12 col-sm-6">-->
<!--                            <div class="form-group m-form__group">-->
<!--                                <label for="organization_id">所属団体</label>-->
<!--                                <select-->
<!--                                    v-model="selectedOrganization"-->
<!--                                    :disabled="user.is_organization"-->
<!--                                    id="organization_id"-->
<!--                                    class="form-control"-->
<!--                                    :class="{ 'is-invalid' : errors.organization_id }">-->
<!--                                    <option :value="null">選択してください</option>-->
<!--                                    <option-->
<!--                                        v-for="organization in organizations"-->
<!--                                        :value="organization">-->
<!--                                        {{ organization.name }}-->
<!--                                    </option>-->
<!--                                </select>-->
<!--                                <div v-if="errors.organization_id"-->
<!--                                     class="invalid-feedback d-block">-->
<!--                                    {{ errors.organization_id[0] }}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-12 col-sm-6">-->
<!--                            <div class="form-group m-form__group">-->
<!--                                <label for="company_id">所属法人</label>-->
<!--                                <select-->
<!--                                    v-model="selectedCompany"-->
<!--                                    :disabled="user.is_company"-->
<!--                                    id="company_id"-->
<!--                                    class="form-control"-->
<!--                                    :class="{ 'is-invalid' : errors.company_id }">-->
<!--                                    <option :value="null">選択してください</option>-->
<!--                                    <option-->
<!--                                        v-for="company in companies"-->
<!--                                        :value="company">-->
<!--                                        {{ company.name }}-->
<!--                                    </option>-->
<!--                                </select>-->
<!--                                <div v-if="errors.company_id"-->
<!--                                     class="invalid-feedback d-block">-->
<!--                                    {{ errors.company_id[0] }}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <div class="form-group m-form__group">
                                <label for="last_name" class="is-required-ja">姓</label>
                                <input
                                    v-model="user.last_name"
                                    id="last_name"
                                    class="form-control m-input"
                                    :class="{ 'is-invalid' : errors.last_name }"
                                    type="text"
                                    placeholder="姓">
                                <div
                                    v-if="errors.last_name"
                                    class="invalid-feedback d-block mt-1">
                                    {{ errors.last_name[0] }}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group m-form__group">
                                <label for="first_name" class="is-required-ja">名</label>
                                <input
                                    v-model="user.first_name"
                                    id="first_name"
                                    class="form-control m-input"
                                    :class="{ 'is-invalid' : errors.first_name }"
                                    type="text"
                                    placeholder="名">
                                <div
                                    v-if="errors.first_name"
                                    class="invalid-feedback d-block mt-1">
                                    {{ errors.first_name[0]}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <div class="form-group m-form__group">
                                <label for="last_name_kana" class="is-required-ja">セイ</label>

                                <input v-model="user.last_name_kana"
                                       id="last_name_kana"
                                       class="form-control m-input"
                                       :class="{ 'is-invalid' : errors.last_name_kana }"
                                       type="text"
                                       placeholder="セイ">

                                <div class="invalid-feedback d-block mt-1" v-if="errors.last_name_kana">
                                    {{errors.last_name_kana[0]}}
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-sm-6">
                            <div class="form-group m-form__group">
                                <label for="first_name_kana" class="is-required-ja">メイ</label>

                                <input v-model="user.first_name_kana"
                                       id="first_name_kana"
                                       class="form-control m-input"
                                       :class="{ 'is-invalid' : errors.first_name_kana }"
                                       type="text"
                                       placeholder="メイ">

                                <div class="invalid-feedback d-block mt-1" v-if="errors.first_name_kana">
                                    {{errors.first_name_kana[0]}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-3">
                            <div class="mb-3">
                                <label>住所（国内/海外）</label>
                                <div class="form-group mt-1">
                                    <div class="form-check form-check-inline">
                                        <input v-model="countrySelect"
                                               type="radio"
                                               id="country_domestic"
                                               class="form-check-input"
                                               @change="countrySelectChange"
                                               value="国内">
                                        <label class="form-check-label"
                                               for="country_domestic">国内
                                        </label>
                                    </div>

                                    <div class="form-check form-check-inline">
                                        <input v-model="countrySelect"
                                               type="radio"
                                               id="country_overseas"
                                               class="form-check-input"
                                               @change="countrySelectChange"
                                               value="海外">
                                        <label class="form-check-label"
                                               for="country_overseas">海外
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <template v-if="countrySelect === '海外'">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="mb-3">
                                    <label for="postcode">郵便番号</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">〒</span>
                                        </div>
                                        <input
                                            v-model="user.postcode"
                                            type="text"
                                            class="form-control"
                                            :class="{ 'is-invalid' : errors.postcode }"
                                            placeholder="000-1111">
                                        <div v-if="errors.postcode"
                                             class="invalid-feedback d-block">
                                            {{ errors.postcode[0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <div class="mb-3">
                                    <label for="address_abroad">住所</label>
                                    <div class="input-group">
                                        <textarea
                                            v-model="user.address"
                                            type="text"
                                            id="address_abroad"
                                            class="form-control"
                                            :class="{ 'is-invalid' : errors.address }"
                                            rows="3"
                                            placeholder="住所を入力してください">
                                        </textarea>

                                        <div v-if="errors.address"
                                             class="invalid-feedback d-block">
                                            {{ errors.address[0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-if="countrySelect === '国内'">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="mb-3">
                                    <label for="postcode">郵便番号</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">〒</span>
                                        </div>
                                        <input v-model="user.postcode"
                                               @change="changePostcode"
                                               type="text"
                                               id="postcode"
                                               class="form-control"
                                               :class="{ 'is-invalid' : errors.postcode }"
                                               placeholder="000-1111">
                                        <div v-if="errors.postcode"
                                             class="invalid-feedback d-block">
                                            {{ errors.postcode[0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="mb-3">
                                    <label for="prefecture">都道府県</label>
                                    <select
                                        v-model="user.prefecture"
                                        id="prefecture"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.prefecture }">
                                        <option value="">選択してください</option>
                                        <option v-for="pref in prefmap" :value="pref">
                                            {{ pref }}
                                        </option>
                                    </select>
                                    <div v-if="errors.prefecture"
                                         class="invalid-feedback d-block">
                                        {{ errors.prefecture[0] }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="mb-3">
                                    <label for="address">市区町村・番地</label>
                                    <input
                                        v-model="user.address"
                                        type="text"
                                        id="address"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.address }"
                                        placeholder="市区町村・番地">
                                    <div v-if="errors.address"
                                         class="invalid-feedback d-block">
                                        {{ errors.address[0] }}
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="mb-3">
                                    <label for="building">建物名など</label>
                                    <input
                                        v-model="user.building"
                                        type="text"
                                        id="building"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.building }"
                                        placeholder="建物名など">
                                    <div v-if="errors.building"
                                         class="invalid-feedback d-block">
                                        {{ errors.building[0] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

                    <div class="row">
                        <div class="col-12 col-sm-4">
                            <div class="form-group m-form__group">
                                <label for="tel">電話番号<span class="small">（滞在している国の国際番号）</span></label>
                                <vue-tel-input
                                    v-model="user.tel"
                                    id="tel"
                                    name="tel"
                                    :class="{ 'is-invalid' : errors.tel || telObj.valid === false }"
                                    placeholder="000-1111-2222"
                                    valid-characters-only
                                    default-country="JP"
                                    @validate="onValidateTel">
                                </vue-tel-input>
                                <div v-if="errors.tel" class="invalid-feedback d-block">{{ errors.tel[0] }}</div>
                                <div v-if="telObj.valid === false" class="invalid-feedback d-block">電話番号を正しく入力してください</div>
                            </div>
                        </div>

                        <div class="col-12 col-sm-4">
                            <div class="form-group m-form__group">
                                <label for="user_em" class="is-required-ja">メールアドレス</label>

                                <input v-model="user.email"
                                       id="user_em"
                                       name="user_em"
                                       class="form-control m-input"
                                       :class="{ 'is-invalid' : errors.email }"
                                       type="text"
                                       autocomplete="off"
                                       placeholder="メールアドレス">

                                <div class="invalid-feedback d-block mt-1" v-if="errors.email">
                                    {{ errors.email[0]}}
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-sm-4">
                            <div class="form-group m-form__group">
                                <label for="user_ps" class="is-required-ja">パスワード</label>
                                <div class="input-group">
                                    <input
                                        v-model="user_password"
                                        id="user_ps"
                                        name="user_ps"
                                        class="form-control m-input"
                                        :class="{ 'is-invalid' : errors.password }"
                                        :type="isShowPassword ? 'text' : 'password'"
                                        autocomplete="new-password"
                                        placeholder="パスワード">
                                    <div
                                        v-b-tooltip.hover
                                        :title="isShowPassword ? 'パスワードを非表示' : 'パスワードを表示'"
                                        class="input-group-append vc-input-password-append"
                                        @click="isShowPassword = !isShowPassword">
                                    <span
                                        v-if="isShowPassword"
                                        class="input-group-text">
                                        <b-icon-eye-slash-fill />
                                    </span>
                                        <span
                                            v-else
                                            class="input-group-text">
                                        <b-icon-eye-fill />
                                    </span>
                                    </div>
                                    <div
                                        v-if="errors.password"
                                        class="invalid-feedback d-block mt-1">
                                        {{ errors.password[0] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <div class="form-group m-form__group">
                                <label for="edit_birth_year">生年月日</label>

                                <div class="d-flex align-items-center">
                                    <select class="form-control"
                                            :class="{ 'is-invalid' : errors.birthday }"
                                            v-model="birth_year"
                                            id="edit_birth_year"
                                            name="birth_year">

                                        <option v-for="n in rangeYear"
                                                :value="n + yearBase">
                                            {{ n + yearBase }}
                                        </option>
                                    </select>
                                    <div class="ml-2 mr-2">年</div>

                                    <select class="form-control"
                                            :class="{ 'is-invalid' : errors.birthday }"
                                            v-model="birth_month"
                                            id="edit_birth_month"
                                            name="birth_month">

                                        <option v-for="n in 12"
                                                :value="n">
                                            {{ n }}
                                        </option>
                                    </select>
                                    <div class="ml-2 mr-2">月</div>

                                    <select class="form-control"
                                            :class="{ 'is-invalid' : errors.birthday }"
                                            v-model="birth_day"
                                            id="edit_birth_day"
                                            name="birth_day">

                                        <option v-for="n in rangeDate"
                                                :value="n">
                                            {{ n }}
                                        </option>
                                    </select>
                                    <div class="ml-2">日</div>
                                </div>

                                <div class="invalid-feedback d-block mt-1" v-if="errors.birthday">
                                    {{ errors.birthday[0] }}
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-sm-6">
                            <div class="m-form__group form-group">
                                <label class="form-control-label">性別</label>
                                <div class="m-radio-inline">
                                    <label class="m-radio mr-2 pt-1">
                                        <input v-model="user.sex"
                                               type="radio"
                                               name="sex"
                                               value="0">
                                        <span>男</span>
                                    </label>
                                    <label class="m-radio mr-2 pt-1">
                                        <input v-model="user.sex"
                                               type="radio"
                                               name="sex"
                                               value="1">
                                        <span>女</span>
                                    </label>
                                </div>
                                <div class="invalid-feedback d-block mt-1" v-if="errors.sex">
                                    {{ errors.sex[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-4">
                            <div class="form-group m-form__group">
                                <label for="edit_height">身長</label>

                                <input v-model="user.height"
                                       id="edit_height"
                                       class="form-control m-input"
                                       :class="{ 'is-invalid' : errors.height }"
                                       type="text"
                                       placeholder="身長">

                                <div class="invalid-feedback d-block mt-1" v-if="errors.height">
                                    {{ errors.height[0] }}
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-sm-4">
                            <div class="form-group m-form__group">
                                <label for="edit_weight">体重</label>

                                <input v-model="user.weight"
                                       id="edit_weight"
                                       class="form-control m-input"
                                       :class="{ 'is-invalid' : errors.weight }"
                                       type="text"
                                       placeholder="体重">

                                <div class="invalid-feedback d-block mt-1" v-if="errors.weight">
                                    {{ errors.weight[0] }}
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-sm-4">
                            <div class="form-group m-form__group">
                                <label for="edit_blood">血液型</label>

                                <select v-model="user.blood"
                                        id="edit_blood"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.blood }">

                                    <option :value="null">選択してください</option>
                                    <option value="A">A型</option>
                                    <option value="B">B型</option>
                                    <option value="O">O型</option>
                                    <option value="AB">AB型</option>
                                </select>

                                <div v-if="errors.blood"
                                     class="invalid-feedback d-block">
                                    {{ errors.blood[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <div class="form-check form-check-inline">
                                <input
                                    v-model="user.is_test"
                                    type="checkbox"
                                    id="is_test"
                                    class="form-check-input"
                                    value="1">
                                <label
                                    for="is_test"
                                    class="mb-0">
                                    テスト用の{{ $locale.patient }}にする
                                </label>
                            </div>
                            <div
                                v-if="errors.is_test"
                                class="invalid-feedback d-block">
                                {{ errors.is_test[0] }}
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <div class="mt-3">
                                <label>管理用タグ</label>
                                <vue-tags-input
                                    v-model="userManagementTag"
                                    :tags="userManagementTags"
                                    @tags-changed="tags => syncUserManagementTag(tags)"
                                    placeholder="管理用タグを追加"
                                />
                                <div v-if="errors.user_management_tags"
                                     class="invalid-feedback d-block">
                                    {{ errors.user_management_tags[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <hr>
                            <ul class="mb-0">
                                <li class="small">パスワードはアルファベット（小・大文字を両方含む）と数字の組み合わせ8～32文字で設定してください</li>
                                <li class="small">
                                    <span>パスワードとして使用可能な記号は</span>
                                    <span>&nbsp;!&nbsp;$&nbsp;%&nbsp;+&nbsp;/&nbsp;=&nbsp;?&nbsp;[&nbsp;]&nbsp;@&nbsp;</span>
                                    <span>です</span>
                                </li>
                                <li class="small">パスワードを変更しない場合は空のままにしてください。</li>
                            </ul>
                            <hr>
                        </div>
                    </div>
                </div>

                <div class="mt-2">
                    <div v-if="$store.state.configs.subscription == 1">
                        <h5>プラン</h5>
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="mb-3">
                                    <label for="plan_id" class="is-required-ja">プラン</label>
                                    <select
                                        v-model="user.plan_id"
                                        @change="onChangePlan"
                                        id="plan_id"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.plan_id }">
                                        <option :value="null">選択してください</option>
                                        <option
                                            v-for="plan in selectablePlans"
                                            :value="plan.id"
                                            :key="`plan_${plan.id}`">
                                            {{ plan.name }}
                                        </option>
                                    </select>
                                    <div
                                        v-if="errors.plan_id"
                                        class="invalid-feedback d-block">
                                        {{ errors.plan_id[0] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="$store.state.configs.subscription == 1">
                        <h5>キャンペーン</h5>
                        <div
                            v-if="user.user_coupons_available_all && user.user_coupons_available_all.length > 0"
                            class="row">
                            <div class="col">
                                <admin-coupons-info
                                    :plan="user.plan"
                                    :campaigns="campaigns"
                                    :coupons="user.user_coupons_available_all"
                                    show-expired-at>
                                    利用可能クーポン
                                </admin-coupons-info>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="mt-3 mb-3">
                                    <label>キャンペーンを追加適用</label>
                                    <div
                                        v-for="(val, index) in selectedCampaignIDs"
                                        :key="`selected-campaign-${index}`"
                                        class="mb-2">
                                        <div class="d-flex align-items-center">
                                            <select
                                                v-model="selectedCampaignIDs[index]"
                                                class="form-control"
                                                :class="{ 'is-invalid' : errors[`campaign_ids.${index}`] }">
                                                <option :value="null">選択してください</option>
                                                <option
                                                    v-for="campaign in selectableCampaigns"
                                                    :value="campaign.id"
                                                    :key="`campaign_${campaign.id}`">
                                                    {{ `${campaign.name}${campaign.name_suffix || ''}` }}
                                                </option>
                                            </select>
                                        </div>
                                        <div
                                            v-if="errors[`campaign_ids.${index}`]"
                                            class="invalid-feedback d-block mt-1 mb-2">
                                            {{ errors[`campaign_ids.${index}`][0] }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="selectedCampaigns"
                                        v-for="campaign in selectedCampaigns">
                                        <ul class="text-muted">
                                            <li>
                                                <span>キャンペーン期間：</span>
                                                <span class="font-weight-bold">{{ getExpiredAt(campaign) }}</span>
                                                <span
                                                    v-if="isGetExpired(campaign)"
                                                    class="font-weight-bold text-danger">
                                                    （取得期限を超過しています）
                                                </span>
                                            </li>
                                            <li>
                                                <span>クーポン使用期限：</span>
                                                <span class="font-weight-bold">{{ expiredDays(campaign) }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <admin-coupons-info
                            v-if="selectedPlan && selectedCoupons.length > 0"
                            :plan="selectedPlan"
                            :campaigns="selectedCampaigns"
                            :coupons="selectedCoupons"
                            show-amount>
                            追加されるクーポン
                        </admin-coupons-info>
                    </div>
                </div>
            </form>

            <div slot="modal-footer" class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
                <button
                    class="btn btn-yokumiru-orange float-right"
                    :disabled="inProgress || telObj.valid === false"
                    @click="handleOk">
                    保存
                </button>

                <button
                    class="btn btn-yokumiru-gray float-right mr-2"
                    :disabled="inProgress"
                    @click="close">
                    キャンセル
                </button>

                <div
                    v-if="filteredSelectedCampaignIDs.length > 0"
                    class="form-check float-right mr-4 mt-2">
                    <input
                        v-model="send_mail"
                        class="form-check-input"
                        type="checkbox"
                        id="send_mail">
                    <label
                        for="send_mail"
                        class="form-check-label">
                        {{ $locale.patient }}に確認メールを送信する
                    </label>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import constants from '../../../constants'
    import YokumiruHelper from '../../../YokumiruHelper'
    import moment from 'moment-timezone'

    export default {
        props: {
            plans: {
                type: Array,
                default: [],
            },
            campaigns: {
                type: Array,
                default: [],
            },
            userCategories: {
                type: Array,
                default: [],
            },
            organizations: {
                type: Array,
                default: [],
            },
            companies: {
                type: Array,
                default: [],
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                modalShow: false,
                send_mail: false,
                inProgress: false,
                user: null,
                user_password: null,
                birth_year: 1900,
                birth_month: 1,
                birth_day: 1,
                yearBase: 1899,
                yearTo: moment().year(),
                errors: [],
                saved: false,
                failed: false,
                prefmap: [
                    '北海道',   '青森県',   '岩手県',   '宮城県',
                    '秋田県',   '山形県',   '福島県',   '茨城県',   '栃木県',
                    '群馬県',   '埼玉県',   '千葉県',   '東京都',   '神奈川県',
                    '新潟県',   '富山県',   '石川県',   '福井県',   '山梨県',
                    '長野県',   '岐阜県',   '静岡県',   '愛知県',   '三重県',
                    '滋賀県',   '京都府',   '大阪府',   '兵庫県',   '奈良県',
                    '和歌山県', '鳥取県',   '島根県',   '岡山県',   '広島県',
                    '山口県',   '徳島県',   '香川県',   '愛媛県',   '高知県',
                    '福岡県',   '佐賀県',   '長崎県',   '熊本県',   '大分県',
                    '宮崎県',   '鹿児島県', '沖縄県',
                ],
                timezones: [],
                countrySelect: null,
                telObj: {},
                selectedCampaignIDs: [null],
                isShowPassword: false,
                selectedUserCategory: null,
                selectedOrganization: null,
                selectedCompany: null,
                userManagementTag: '',
                userManagementTags: [],
            }
        },

        watch: {
            'selectedOrganization.id': function (id) {
                if (!this.user) return

                const org = this.organizations.find((org) => org.id === id)
                const plan = org.plans.find((plan) => plan.id === this.user.plan_id)

                // 選択された団体が利用可能なプランでなければ初期化
                if (!plan) {
                    this.user.plan_id = null
                }
                // 団体が選択された場合はメール通知しない
                if (id) {
                    this.send_mail = false
                }
            },

            'selectedCompany.id': function (id) {
                if (!this.user) return

                const company = this.companies.find((company) => company.id === id)
                const plan = company.plans.find((plan) => plan.id === this.user.plan_id)

                // 選択された法人が利用可能なプランでなければ初期化
                if (!plan) {
                    this.user.plan_id = null
                }
                // 法人が選択された場合はメール通知しない
                if (id) {
                    this.send_mail = false
                }
            },
        },

        computed: {
            /**
             * 会員登録日時
             */
            registeredAt: function () {
                if (!this.user) return null

                return moment(this.user.registered_at)
            },

            /**
             * 選択されたキャンペーンID（null除外）
             *
             * @return {array}
             */
            filteredSelectedCampaignIDs: function () {
                return this.selectedCampaignIDs.filter(id => id !== null)
            },

            /**
             * 選択可能キャンペーンリスト
             *
             * @return {array}
             */
            selectableCampaigns: function () {
                // 表示フラグが立っているか
                let campaigns = this.campaigns.filter((campaign) => campaign.flg_show === 1)

                // 所属コードのフィルタリング
                campaigns = campaigns.filter((campaign) => {
                    return campaign.user_code === null || (campaign.user_code && campaign.user_code === this.user.user_code)
                })

                return campaigns
            },

            /**
             * 選択可能プランリスト
             *
             * @return {array}
             */
            selectablePlans: function () {
                if (!this.user || !this.user.plan) {
                    return this.plans
                }

                let plans = [...this.plans]

                // グループに所属する会員なら利用可能なプランに絞る
                if (this.helper.isGroupUser(this.user)) {
                    const groupPlans = this.helper.retrieveUserGroupPlans(this.user)
                    plans = this.plans.filter((plan) => groupPlans.some((gp) => gp.id === plan.id))
                }

                // サービスモデルのリストに自身のサービスモデルを追加
                plans.push(this.user.plan)

                // 重複排除
                // @see https://qiita.com/allJokin/items/28cd023335641e8796c5
                return Array.from(
                    new Map(plans.map((plan) => [plan.id, plan])).values()
                )
            },

            /**
             * 選択されたプラン
             *
             * @return {object|null}
             */
            selectedPlan: function () {
                if (!this.user.plan_id) {
                    return null
                }
                return this.selectablePlans.find(plan => plan.id === this.user.plan_id)
            },

            /**
             * 選択されたキャンペーン
             *
             * @return {array}
             */
            selectedCampaigns: function () {
                return this.campaigns.filter(campaign => this.selectedCampaignIDs.includes(campaign.id))
            },

            /**
             * 選択されたキャンペーン内のクーポン
             *
             * @return {array}
             */
            selectedCoupons: function () {
                const coupons = []
                this.filteredSelectedCampaignIDs.forEach((id) => {
                    const campaign = this.selectedCampaigns.find(campaign => campaign.id === id)
                    campaign.coupons.forEach(coupon => coupons.push(coupon))
                })
                return coupons
            },

            rangeYear: function() {
                return this.yearTo - this.yearBase;
            },

            rangeDate: function() {
                if (this.birth_year && this.birth_month) {
                    const current =
                        this.birth_year.toString() + '-' +
                        this.birth_month.toString().padStart( 2, '0' ) + '-' + '01';

                    return moment( current ).endOf( 'month' ).date();
                }
                else {
                    return 1
                }
            },
        },

        created: function() {
            bus.$on('open-modal-edit-user', this.open)
            this.fetchTimezones()
        },

        beforeDestroy: function() {
            bus.$off('open-modal-edit-user')
        },

        methods: {
            /**
             * クーポン取得期限表記
             *
             * @param {object} campaign
             * @return {string}
             */
            getExpiredAt: function (campaign) {
                if (campaign.get_expire_day_at) {
                    return moment(campaign.get_expire_day_at).locale('ja').format('YYYY年M月D日(ddd)まで')
                }
                else if (campaign.get_expire_days) {
                    return moment().locale('ja').add(campaign.get_expire_days, 'days').format('YYYY年M月D日(ddd)まで')
                }
                else if (campaign.get_expire_registration_days) {
                    return this.registeredAt.locale('ja').add(campaign.get_expire_registration_days, 'days').format('YYYY年M月D日(ddd)まで')
                }

                return '無期限'
            },

            /**
             * 取得期限切れ判定
             *
             * @param {object} campaign
             * @returns {boolean}
             */
            isGetExpired: function (campaign) {
                if (campaign.get_expire_registration_days) {
                    return moment().isSameOrAfter(this.registeredAt)
                }
                return false
            },

            /**
             * クーポン使用期限表記
             *
             * @param {object} campaign
             * @return {string}
             */
            expiredDays: function (campaign) {
                if (campaign.expire_day_at) {
                    return moment(campaign.expire_day_at).format('YYYY年M月D日(ddd)まで')
                }
                else if (campaign.expire_days) {
                    return `取得後${campaign.expire_days}日間`
                }
                return `無期限`
            },

            /**
             * 選択中のプランが変更された場合、選択中のキャンペーンをリセット
             */
            onChangePlan: function () {
                this.selectedCampaignIDs = [null]
            },

            /**
             * 所属コードが変更された場合、選択中のキャンペーンをリセット
             */
            onChangeUserCode: function () {
                this.selectedCampaignIDs = [null]
            },

            onValidateTel: function (object) {
                if (object.number.input) {
                    this.telObj = object
                }
                else {
                    this.telObj = {
                        number: { e164: null, national: null },
                        valid: true,
                        regionCode: null,
                    }
                }
            },

            /**
             * 会員管理用タグの初期化
             */
            initUserManagementTag: function () {
                if (!this.user || this.user.user_management_tags.length < 1) {
                    this.userManagementTags = []
                    return
                }

                this.userManagementTags = this.user.user_management_tags.map((tag) => {
                    return {
                        id: tag.id,
                        text: tag.name,
                        style: 'color: #3461b4; background-color: #f2f4f8; border: 1px solid #dce4ed;',
                    }
                })
            },

            /**
             * 医師管理用タグ追加時の同期処理
             * @param {array} tags
             */
            syncUserManagementTag: function (tags) {
                this.userManagementTags = tags.map((lbl) => {
                    return {
                        text: lbl.text,
                        style: 'color: #3461b4; background-color: #f2f4f8; border: 1px solid #dce4ed;',
                        tiClasses: ['ti-valid'], // VueTagsInputが自動生成している
                    }
                })
            },

            countrySelectChange: function() {
                if (this.countrySelect === '海外') {
                    this.user.country = ''
                    this.user.prefecture = ''
                }
                else{
                    this.user.country = '日本'
                    this.user.prefecture = ''
                }
            },

            /**
             * モーダルを表示
             *
             * @param {object} user
             */
            open: function (user) {
                this.user = {...user}

                this.user.password = null
                this.countrySelect = this.$locale.type === 'consul' ? '海外' : '国内'
                this.birth_year = user.birthday ? moment(user.birthday).year() : null
                this.birth_month = user.birthday ? moment(user.birthday).month() + 1 : null
                this.birth_day = user.birthday ? moment(user.birthday).date() : null
                this.selectedCampaignIDs = [null]
                this.isShowPassword = false
                this.user_password = null

                this.selectedUserCategory = this.userCategories.find((category) => category.id === user.user_category_id)

                const currentOrganization = this.helper.userOrganization(user)
                this.selectedOrganization = currentOrganization ? this.organizations.find((org) => org.id === currentOrganization.id) : null

                const currentCompany = this.helper.userCompany(user)
                this.selectedCompany = currentCompany ? this.companies.find((company) => company.id === currentCompany.id) : null

                this.initUserManagementTag()

                this.send_mail = false
                this.errors = {}

                this.modalShow = true
            },

            /**
             * モーダルを閉じる
             */
            close: function() {
                this.modalShow = false
            },

            /**
             * 保存ボタン押下時
             *
             * @param {object} e
             */
            handleOk(e) {
                e.preventDefault()
                this.editUser()
            },

            /**
             * 患者の編集保存
             *
             * @return {void}
             */
            editUser: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const user = Object.assign({}, this.user)

                if (this.birth_year && this.birth_month && this.birth_day) {
                    user.birthday = this.birth_year.toString() + '-' +
                        this.birth_month.toString().padStart( 2, '0' ) + '-' +
                        this.birth_day.toString().padStart( 2, '0' )
                }

                user.tel = this.telObj.number.e164
                user.tel_national = this.telObj.number.national
                user.tel_region = this.telObj.regionCode

                user.campaign_ids = this.filteredSelectedCampaignIDs
                user.send_mail = this.send_mail && this.filteredSelectedCampaignIDs.length > 0

                if (this.$store.state.configs.timezone != 1) {
                    delete user.timezone
                }

                if (this.user_password && this.user_password.length > 0) {
                    user.password = this.user_password
                }

                user.user_category_id = this.selectedUserCategory ? this.selectedUserCategory.id : null
                user.organization_id = this.selectedOrganization ? this.selectedOrganization.id : null
                user.company_id = this.selectedCompany ? this.selectedCompany.id : null

                user.user_management_tags = []
                this.userManagementTags.forEach((tag) => {
                    user.user_management_tags.push(tag.text)
                })

                const endpoint = constants.admin.users.endpoint.base

                await axios.post(`${endpoint}/${user.id}`, user)
                    .then(() => {
                        bus.$emit('alert-success', `${this.$locale.patient}の登録内容を変更しました。`)
                        bus.$emit('fetch-users')
                        this.close()
                    })
                    .catch(({response}) => {
                        if (response.data.hasOwnProperty('errors')) {
                            if (response.data.errors.hasOwnProperty( 'message' )) {
                                bus.$emit('alert-danger', response.data.errors.message[0])
                            } else {
                                bus.$emit('alert-danger')
                                this.errors = response.data.errors
                            }
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },

            /**
             * 郵便番号入力時
             */
            changePostcode: function() {
                let postcode = this.user.postcode;
                postcode = postcode.replace( '-', '' );

                axios.get( `${constants.admin.zip.endpoint.base}?postcode=${postcode}` )
                    .then( ({data}) => {
                        try {
                            let newPrefecture = data.data[0].ja.prefecture;
                            let newAddress = data.data[0].ja.address1 + data.data[0].ja.address2 + data.data[0].ja.address3+ data.data[0].ja.address4;
                            this.user.prefecture = newPrefecture;
                            this.user.address = newAddress;
                        }
                        catch (e) {
                            this.user.prefecture = "";
                            this.user.address = "";
                            console.log( '__YokumiruAPI__ : 住所情報の取得に失敗しました。' );
                        }
                    } );
            },

            fetchTimezones: function () {
                axios.get(constants.admin.users.endpoint.timezone)
                    .then(({data}) => {
                        const momentTimezones = moment.tz.names()
                        this.timezones = data.data.filter((d) => momentTimezones.includes(d.key))
                    })
            },
        },
    }
</script>

<style scoped lang="scss">
    .vc-input-password-append {
        cursor: pointer;
    }
</style>
